import {useEffect, useMemo, useState} from "react";
import {AmiRepository} from "../../../../repositories/AmiRepository";

// The AMI extensions of a (registry) project, narrowed to one sub project when subProjectId is given, plus a
// lookup by id for showing a campaign's extensionId
export const useAmiExtensions = (projectId, subProjectId) => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    setError(false);
    AmiRepository.listExtensions(projectId, subProjectId)
      .then(res => setExtensions(res?.data?.extensions || []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [projectId, subProjectId]);

  const byId = useMemo(() => {
    const map = new Map();
    extensions.forEach(ext => ext.id && map.set(String(ext.id), ext));
    return map;
  }, [extensions]);

  const getExtension = (id) => (id ? byId.get(String(id)) || null : null);

  return {extensions, loading, error, getExtension};
};

// "950001 · Support bot"
export const extensionLabel = (ext) => ext ? [ext.extension, ext.name].filter(Boolean).join(" · ") : "";
